/* global FormData */

import {
  addClass,
  removeClass,
  toggleClass,
  hasClass,
  nodesToArray,
  elementInViewport,
} from '../utils/helpers'
import { smoothScroll } from '../utils/actions'
import { AJAX_URL } from '../utils/constants'

const submitButtonSelector = '.js-submitButton'
const responseSelector = '.js-formResponse'
const activeClass = 'is-active'
const errorClass = 'is-error'
const loadingClass = 'is-loading'
const errorMessage =
  'Något gick fel men vi vet inte exakt vad. Du kan maila ditt meddelande direkt till <a target="_blank" href="mailto:info@rikskriscentrum.se">info@rikskriscentrum.se</a>.'

let ResponseEl
let Errors = []

export default class {
  constructor(el, options) {
    options = this.options = Object.assign({}, this.options, options)
    this.el = el
    this.submitButton = el.querySelector(submitButtonSelector)
    this.inputFields = el.querySelectorAll('input, textarea')
    ResponseEl = el.querySelector(responseSelector)

    this.el.addEventListener('submit', this.onSubmit.bind(this), false)

    nodesToArray(this.inputFields).forEach((input, index) => {
      input.addEventListener('keydown', this.onKeydown, false)
    })
  }

  onKeydown(e) {
    if (Errors.length > 0 && hasClass(e.target, errorClass)) {
      removeClass(e.target, errorClass)
      e.target.removeEventListener('keydown', this.onKeydown, false)
    }
  }

  onSubmit(e) {
    const form = this
    const data = {}
    Errors = []

    removeClass(ResponseEl, activeClass)

    nodesToArray(this.inputFields).forEach((el, index) => {
      if (el.getAttribute('data-test')) {
        if (index === 0) {
          el.focus()
        }

        Errors.push(el.name)

        addClass(el, errorClass)
      } else {
        removeClass(el, errorClass)

        if (Errors.length === 0) {
          Object.assign(data, {
            [encodeURIComponent(el.name)]: encodeURIComponent(el.value),
          })
        }
      }
    })

    if (Errors.length) {
      e.preventDefault()
      return
    }

    form.submitButton.disabled = true
    addClass(form.submitButton, loadingClass)

    window
      .fetch(AJAX_URL, {
        method: 'post',
        body: new FormData(form.el),
      })
      .then(form.checkStatus)
      .then(form.parseJSON)
      .then((data) => {
        form.submitButton.disabled = false
        removeClass(form.submitButton, loadingClass)
        addClass(ResponseEl, activeClass)

        ResponseEl.innerHTML = data.return_message || data

        if (!elementInViewport(ResponseEl)) {
          window.setTimeout(() => {
            ResponseEl.scrollIntoView({ behavior: 'smooth' })
          }, 200)
        }

        if (data.fields_with_errors && data.fields_with_errors.length) {
          Errors = data.fields_with_errors
          form.toggleErrors(data.fields_with_errors)
        }
      })
      .catch((error) => {
        form.submitButton.disabled = false
        removeClass(form.submitButton, loadingClass)

        addClass(ResponseEl, activeClass)
        // ResponseEl.innerHTML = data.return_message || errorMessage

        if (data.fields_with_errors && data.fields_with_errors.length) {
          Errors = data.fields_with_errors
          form.toggleErrors(data.fields_with_errors)
        }

        if (!elementInViewport(ResponseEl)) {
          window.setTimeout(() => {
            ResponseEl.scrollIntoView({ behavior: 'smooth' })
          }, 200)
        }
      })

    e.preventDefault()
  }

  checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
      return response
    }

    const error = new Error(response.statusText)
    error.response = response

    ResponseEl.innerHTML = errorMessage

    throw error
  }

  parseJSON(response) {
    return response.json()
  }

  toggleErrors(errorFields = []) {
    if (errorFields.lenght > 0) {
      document.getElementById(errorFields[0]).focus()
    }

    nodesToArray(this.el.querySelectorAll('input, textarea')).forEach((el) => {
      toggleClass(el, errorClass, errorFields.indexOf(el.id) > -1)
    })
  }
}
